<template>
  <div />
</template>

<script>
import { getCacheConfig } from '@/utils'
import { getRewardType } from '@/api/config/slot'
import { getBuildBoxAllCfg } from '@/api/config/blind-box-cfg'
import { getAnimalAllList, getShieldsAllList, getSieveAllList } from '@/api/config/area-cfg'
import { getChestCfgAll } from '@/api/config/chest-skin-cfg'
import { getAvatarCfgAll } from '@/api/config/avatar-cfg'
import { getActivityTypeToMap } from '@/api/config/activity-cfg'
import { getChestPropCfgAll } from '@/api/config/chest-prop-cfg'

export default {
  name: 'InitReward',
  data() {
    return {
      ucType: 1
    }
  },
  created() {
    this.initConfig()
  },
  methods: {
    initConfig() {
      Promise.all([
        getCacheConfig(getRewardType, 'getRewardType' + this.ucType, { data: this.ucType }),
        getCacheConfig(getBuildBoxAllCfg, 'getBuildBoxAllCfg'),
        getCacheConfig(getAnimalAllList, 'getAnimalAllList'),
        getCacheConfig(getShieldsAllList, 'getShieldsAllList'),
        getCacheConfig(getSieveAllList, 'getDiceAllList'),
        getCacheConfig(getChestCfgAll, 'getChestCfgAll'),
        getCacheConfig(getAvatarCfgAll, 'getAvatarCfgAll'),
        getCacheConfig(getActivityTypeToMap, 'getActivityTypeToMap'),
        getCacheConfig(getChestPropCfgAll, 'getChestPropCfgAll')
      ]).then(() => {
        console.log('奖励配置预加载完成')
      })
    }
  }
}
</script>

<style scoped>

</style>
